export default {
  computed: {
    logoDescription () {
      return 'company logo'
    },
    estimateProject () {
      return 'Wyceń projekt';
    },
    nameInvalid () {
      return 'Proszę wypełnić to pole' + ' - ' + 'Imię i nazwisko'
    },
    namePlaceholder () {
      return 'Imię i nazwisko'
    },
    emailInvalid () {
      return 'Adres e-mail jest nieprawidłowy'
    },
    emailPlaceholder () {
      return 'E-mail'
    },
    phoneInvalid () {
      return 'Numer telefonu jest nieprawidłowy'
    },
    phonePlaceholder () {
      return 'Numer telefonu'
    },
    descriptionInvalid () {
      return 'Proszę wypełnić to pole' + ' - ' + 'Opisz nam swój projekt, wątpliwości oraz oczekiwania.'
    },
    descriptionPlaceholder () {
      return 'Opisz nam swój projekt, wątpliwości oraz oczekiwania.'
    },
    rodoInvalid () {
      return 'Musisz wyrazić zgodę na przetwarzanie swoich danych osobowych przed wysłaniem formularza'
    },
    rodoPlaceholder () {
      return 'Wyrażam zgodę na przetwarzanie moich danych osobowych w celu otrzymywania informacji handlowych od Smartbees Sp. z o.o.'
    },
    submitForm () {
      return 'Wyceń projekt'
    },
    successHeader () {
      return 'Twoja wiadomość została <strong>pomyślnie wysłana</strong>'
    },
    successFooter () {
      return 'Odezwiemy się do Ciebie maksymalnie w ciągu 24 godzin, aby omówić szczegóły zapytania i dopasować rozwiązanie do Twoich potrzeb.'
    },
    popupCloseMessage () {
      return 'Pop-up zostanie zamknięty zamknięty' + ' '
    },
    errorHeader () {
      return 'Przepraszamy, wystąpił nieoczekiwany błąd <strong>Spróbuj ponownie</strong>'
    },
    defaultHeader () {
      return 'Some default'
    },
    defaultHeaderBold () {
      return 'content'
    },
    defaultFooter () {
      return 'Współpracowaliśmy z:'
    },
    defaultIconOne () {
      return '<strong>Napiszemy lub zadzwonimy do Ciebie w ciągu 24 godzin,</strong> aby lepiej poznać Twoje oczekiwania względem projektu. Dzięki temu nasza wycena będzie precyzyjna.'
    },
    defaultIconTwo () {
      return '<strong>Przedstawimy Ci wycenę projektu,</strong> która uwzględni wszystkie kluczowe elementy proponowanego rozwiązania.'
    },
    defaultIconThree () {
      return '<strong>Doradzimy Ci i pomożemy</strong> w dopasowaniu odpowiednich funkcjonalności, aby projekt był zgodny z potrzebami Twojego biznesu.'
    },
    captchaError () {
      return 'Proszę zaznaczyć captcha'
    },
    sendingInfo () {
      return 'Wysyłam twoje zapytanie...'
    }
  }
}
